module.exports = __webpack_public_path__ + "static/media/modal-video.49f9f408.scss";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-modal-video/scss/modal-video.scss
// module id = 246
// module chunks = 0